import request from 'utils/request'

// 获取待办事项
export const getUpcoming = () => request().get('credit/task/count')

// 获取工作委托记录
export const getWorkRecording = () => request().get('bp/task/delegate/list')

// 获取被委托记录
export const getDelegatedRecording = () =>
  request().get('bp/task/delegate/agent/list')

// 获取工作委托对象
export const getWorkObject = () => request().get('bp/task/delegate/listAgent')

// 获取业务类型
export const getBusinessType = () => request().get('business/mode/jsonList')

// 取消委托
export const handleCancel = id => request().get(`bp/task/delegate/delete/${id}`)

// 增加或者修改委托
export const updateRecording = data => request().post('bp/task/delegate', data)

// 获取委托记录
export const getDelegateRecording = data =>
  request().post('bp/task/delegate/page', data)
// 获取被委托记录

export const getgateRecoeding = data =>
  request().post('bp/task/agent/page', data)
// 提醒事项数据获取
export const getRemindData = () => request().get('customer/alert/count')

// 限额超担保
export const getASURData = params =>
  request().post('assurance/pageLimitOver', params)
// 限额超保险
export const getINSUData = params =>
  request().post('insurance/pageLimitOver', params)
// 获取逾期30天以上客户记录
export const getOverdueThirty = data =>
  request().post('customer/risk/page', data)
// 逾期客户
export const getOverdueForth = data =>
  request().post('customer/ar/overdue/overThirty/page', data)
// 近30天到期限额和额度
export const getExpirationLimit = data =>
  request().post('amount/expiration/inThirty/amount/page', data)

// 获取近一个月担保最近到期额度记录
export const getExpirationLoan = data =>
  request().post('assurance/pageInThirty', data)
// 保险
export const getInsureanceLoan = data =>
  request().post('insurance/pageInThirty', data)

// 查询是否展示两个图
export const queryEnablePics = () => request().post('role/special_btn')
export const getBusinessList = () => request().get('business/jsonList')

// 获取信用趋势折线图数据
export const getLineData = data =>
  request().post('company/amount/statistics_all', data)

// 获取饼状图数据
export const getPieData = data =>
  request().post('customer/ar/aggregation/sum', data)

// 获取待审批列表
export const getApproveList = data => request().post('bp/task/page', data)

// 获取批量待审批列表
export const getBatchApproveList = data =>
  request().post('bp/batch/task/page', data)

// 获取审批通过列表
export const getApprovedList = data =>
  request().post('bp/approve/pageMine', data)

// 获取审批未通过列表
export const getRejectedList = data =>
  request().post('bp/approve/pageMine', data)
// 集团关系待审批
export const getGroupApproveList = data =>
  request().post('relation/task/page', data)
// 集团关系批量待审批
export const getGroupBrachApproveList = data =>
  request().post('relation/batch/task/page', data)
export const getGuaranteeApproved = data =>
  request().post('assurance/task/page', data)

// 获取待审批列表
export const getApproveAllList = data => request().post('bp/task/pageAll', data)
// 集团关系待审批
export const getGroupApproveAllList = data =>
  request().post('relation/task/pageAll', data)
// 集团关系待审批
export const getLimitAllList = data => request().post('limit/task/pageAll', data)
// 账期调整待审批
export const getPeriodAllList = data => request().post('period/approveTerm/pageAll', data)
// 获取待办事项
export const getUpcomings = () => request().get('credit/task/counts')